@use '@fukuri-admins/ui/layout' as *;

.FieldWrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('4');

  &__Label {
    display: flex;
    align-items: center;
    gap: spacing('4');

    @include typography('Jp/14_W3');
    color: text('High');
    width: 100%;
  }

  &__RequiredLabel {
    @include typography('Jp/12_W3');
    color: text('Red');
  }

  &__BeforeMessage {
    color: text('Low');
    @include typography('Jp/12_W3');
  }

  &__ChildrenContainer {
    flex: 1;
  }
}
